export enum InvoicingButton {
   Emitir,
   Previsualizar,
   Cancelar,
   FacturarGuias,
}
